export { default as NewProfileVolumeByLocation } from './NewProfileVolumeByLocation';
